var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.prospect && _vm.showRider ? _c('div', {
    staticClass: "d-contents"
  }, [_c('div', {
    class: [_vm.$style.prospectContainer],
    style: {
      bottom: _vm.bottomOffset + 'px'
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('openProspect');
      }
    }
  }, [_c('div', {
    class: _vm.$style.iconContainer
  }, [_c('BaseIcon', {
    class: _vm.$style.userPlusIcon,
    attrs: {
      "name": "user-plus"
    }
  })], 1)])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }